import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const InteractiveBox = styled(Box)`
  padding: 16px 20px 20px;

  border-radius: ${theme.token.var('borderRadius.small')};
  background-color: ${theme.token.var('colors.green.a25')};
  overflow: hidden;
`
